module.exports = __webpack_public_path__ + "img/logo.515fe6dd.png";